import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ModalService } from '../../core/services/modal.service';

export type Options = {
	text: string;
	header?: string;
	confirm?: string;
	cancel?: string;
}

@Component({
	selector: 'app-confirm-modal-v2',
	templateUrl: './confirm-modal-v2.component.html',
	styleUrls: ['./confirm-modal-v2.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ConfirmModalV2Component {
	@Input() modalId: string;

	@Input() options: Options = {
		text: '',
		header: 'Are you sure?',
		confirm: 'Confirm',
		cancel: 'Cancel',
	};

	@Output() confirmed = new EventEmitter();

	constructor(
		private modalService: ModalService,
	) {}

	cancel() {
		this.modalService.close(this.modalId);
	}

	confirm() {
		this.confirmed.emit();
		this.cancel();
	}
}
